import { Link } from 'react-router-dom';
import { ChevronRight } from 'lucide-react';
import { isGenericGroupName } from '../../lib/proximity/data/userGroups';
import { groupHomePath } from '../../config/productSurfaces';
import GroupAvatarStack from './GroupAvatarStack';

/**
 * Your groups for one event, drawn as the Groups page draws them (Sam, 2026-10-26: the event page still showed the
 * 👥 card and "matched on shared taste" from match-me). The event is the page, so a row is the group's name and faces.
 */
export default function EventGroupRows({ groups, max = 3, past = false, onNavigate }) {
  return (
    <ul className="list-index__list">
      {groups.slice(0, max).map((g) => {
        const name = (g.name || '').trim();
        const people = g.members || [];
        return (
          <li key={g.id}>
            <Link
              to={groupHomePath(g.id)}
              onClick={() => onNavigate?.()}
              className={`list-index__row${past ? ' list-index__row--past' : ''}`}
            >
              <span className="list-index__text">
                <span className="list-index__name">
                  {name && !isGenericGroupName(name) ? name : 'Your group'}
                </span>
                <span className="groups-index__faces">
                  {people.length > 0 && (
                    <GroupAvatarStack people={people} max={5} size="xxs" overlapPx={-6} />
                  )}
                  <span>
                    {g.memberCount} {g.memberCount === 1 ? 'member' : 'members'}
                  </span>
                </span>
              </span>
              <ChevronRight size={17} aria-hidden="true" />
            </Link>
          </li>
        );
      })}
    </ul>
  );
}
